/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LearningRedirectResponseDto
 */
export interface LearningRedirectResponseDto {
    /**
     * Indicates if the redirect was successful
     * @type {boolean}
     * @memberof LearningRedirectResponseDto
     */
    success: boolean;
    /**
     * SSO URL to redirect user to LearnWorlds. Only present if success is true
     * @type {string}
     * @memberof LearningRedirectResponseDto
     */
    url?: string;
    /**
     * Error message if redirect failed
     * @type {string}
     * @memberof LearningRedirectResponseDto
     */
    message?: string;
}

/**
 * Check if a given object implements the LearningRedirectResponseDto interface.
 */
export function instanceOfLearningRedirectResponseDto(value: object): value is LearningRedirectResponseDto {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function LearningRedirectResponseDtoFromJSON(json: any): LearningRedirectResponseDto {
    return LearningRedirectResponseDtoFromJSONTyped(json, false);
}

export function LearningRedirectResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LearningRedirectResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'url': json['url'] == null ? undefined : json['url'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function LearningRedirectResponseDtoToJSON(json: any): LearningRedirectResponseDto {
    return LearningRedirectResponseDtoToJSONTyped(json, false);
}

export function LearningRedirectResponseDtoToJSONTyped(value?: LearningRedirectResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'url': value['url'],
        'message': value['message'],
    };
}

